<template>
  <div class="customer-info">
    <div class="info-header">
      <h2 class="section-title">Subscription Renewal</h2>
    </div>

    <div class="info-card">
      <div class="customer-details">
        <div class="detail-row">
          <span class="detail-label">Customer</span>
          <span class="detail-value customer-name">{{ reference.debtor_name }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Amount Due</span>
          <span class="detail-value amount">{{ $utils.formatMoney(reference.amount) }}</span>
        </div>
      </div>

      <p class="renewal-message">
        Your Point of Sale service subscription is due for renewal.
        Complete your payment to secure continuous service.
      </p>

      <div class="invoice-link" v-if="reference.salenum">
        <a :href="invoiceUrl" target="_blank" rel="noopener" class="link-button">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          View Invoice
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerInformation',
  props: {
    reference: {
      type: Object,
      required: true
    }
  },
  computed: {
    invoiceUrl() {
      if (!this.reference || !this.reference.salenum) return '#'
      return `https://chrilantech.com/LytSoftPosOnline/api/PDFReport/getInvoiceFromSaleNumber/${this.reference.salenum}/burntofi_chrilan`
    }
  }
}
</script>

<style scoped>
.customer-info {
  margin-bottom: 1.5rem;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #18181b;
  margin: 0 0 1rem 0;
}

.info-card {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 0.75rem;
  padding: 1.5rem;
}

.customer-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f4f4f5;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-label {
  font-size: 0.875rem;
  color: #71717a;
  font-weight: 500;
}

.detail-value {
  font-weight: 600;
  color: #18181b;
}

.customer-name {
  font-size: 1.125rem;
}

.amount {
  font-size: 1.25rem;
  color: #0ea5e9;
}

.renewal-message {
  font-size: 0.9375rem;
  color: #52525b;
  line-height: 1.6;
  margin: 0 0 1rem 0;
}

.invoice-link {
  margin-top: 0.5rem;
}

.link-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #0ea5e9;
  text-decoration: none;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  background: #f0f9ff;
  transition: all 0.2s;
}

.link-button:hover {
  background: #e0f2fe;
  color: #0284c7;
}

.icon {
  width: 1rem;
  height: 1rem;
}

@media (max-width: 576px) {
  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .section-title {
    font-size: 1.25rem;
  }
}
</style>
